/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @angular-eslint/component-selector */
import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxDropzoneModule, NgxDropzonePreviewComponent } from 'ngx-dropzone';
// import { SWALConfirmation } from 'src/app/app-const';
import { AttachmentService } from 'src/app/core/backend/common/services';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'custom-image-previewer-plus'!,
  standalone: true,
  imports: [NgxDropzoneModule, CommonModule],
  providers: [
    {
      provide: NgxDropzonePreviewComponent,
      useExisting: CustomImagePreviewerPlusComponent,
    },
  ],
  templateUrl: './custom-image-previewer-plus.component.html',
  styleUrls: ['./custom-image-previewer-plus.component.scss'],
})
export class CustomImagePreviewerPlusComponent
  extends NgxDropzonePreviewComponent
  implements OnInit
{
  domain = environment.api;
  @Input() loading = false;
  @Input() url: string | undefined | null = '';
  @Input() files: any[] = [];
  @HostBinding('class')
  classes = '';

  public get fileTypeClass(): 'img' | 'file' {
    const fileName = this.fileType.toLowerCase();
    if (
      fileName.includes('png') ||
      fileName.includes('jpg') ||
      fileName.includes('jpeg') ||
      fileName.includes('gif') ||
      fileName.includes('svg') ||
      fileName.includes('webp') ||
      fileName.includes('jfif')
    ) {
      return 'img';
    }

    return 'file';
  }

  @Input() type: 'IMG' | 'FILE' = 'FILE';
  @Output() override removed: EventEmitter<File> = new EventEmitter<File>();
  @Output() fileRemoved: EventEmitter<string> = new EventEmitter<string>();

  removeFileFromList(url: string): void {
    const index = this.files.indexOf(url);
    if (index !== -1) {
      this.files.splice(index, 1);
    }
  }

  override _remove(event: any): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.url) {
      Swal.fire({
        title: 'هل تريد حذف هذا الملف؟',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'نعم، احذف',
        cancelButtonText: 'إلغاء',
      })
        .then((result) => {
          if (result.isConfirmed) {
            this.removeFileFromList(this.url ?? '');
            this.url = undefined;
            this.fileRemoved.emit(this.url || undefined);
            this.classes = 'd-none';
            Swal.fire('تم الحذف', '', 'success');
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  public get fileType(): string {
    return this.url?.slice(this.url.lastIndexOf('.') + 1) || '';
  }

  constructor(
    sanitizer: DomSanitizer,
    private attachmentService: AttachmentService,
  ) {
    super(sanitizer);
  }

  ngOnInit(): void {
    this.classes = this.type;
  }
}
